import React, { useEffect, useState } from "react";

import { useExercise } from "../hooks/exerciseHook";
import { PALETTE } from "../../common/ThemeConstants";
import ReactPlayer from "react-player";
import DetailSector from "../../common/components/DetailSector";
import { useNavigate } from "react-router-dom";
import DetailsHeader from "../../common/components/DetailsHeader";
import { Col, Container, Row } from "react-bootstrap";
import ExerciseHeader from "../components/ExerciseHeader";
import { useWindowWidth } from "../../api/useWindowWidth";
import { FaPlay } from "react-icons/fa";
import ContainerResponsive from "../../common/components/ContainerResponsive";
import FullScreenVideo from "../../common/components/FullScreenVideo";

export default function Exercise() {
  const exerciseContext = useExercise();
  const navigate = useNavigate();
  const [_, isMobile] = useWindowWidth();
  const [isLocked, setIsLocked] = useState(false);
  const [exercise, setExercise] = useState({
    id: -1,
    name: "no title",
    description: "",
    cover: "",
    video: "",
  });
  const [playing, setPlaying] = useState(false);

  const paddingBottom = isLocked ? 40 : 20;

  const onVideoPlay = () => {
    const video = document.getElementById("workout-video").children[0];
    if (video.requestFullscreen) {
      video.requestFullscreen();
    } else if (video.mozRequestFullScreen) {
      // Firefox
      video.mozRequestFullScreen();
    } else if (video.webkitRequestFullscreen) {
      // Chrome, Safari and Opera
      video.webkitRequestFullscreen();
    } else if (video.msRequestFullscreen) {
      // IE/Edge
      video.msRequestFullscreen();
    } else if (video.webkitEnterFullscreen) {
      // iOS
      video.webkitEnterFullscreen();
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    setIsLocked(exerciseContext.exerciseData.isLocked);
    setExercise(exerciseContext.exerciseData);

  }, [exerciseContext.exerciseData.isLocked, exerciseContext.exerciseData]);

  return (
    <div>
      <FullScreenVideo url={exercise.video} show={playing} onClose={() => setPlaying(false)} />
      {isMobile ? <DetailsHeader /> : <ExerciseHeader title={exercise.name} showInfo={false} />}
      {isLocked && (
        <div>
          <div
            style={{
              position: "fixed",
              height: "115vh",
              width: "100%",
              top: "-15vh",
              textAlign: "center",
              backgroundColor: "#f5f5f5c2",
              zIndex: 100,
            }}
          />
          <div
            className="m-auto px-2"
            style={{ width: "100%", bottom: 40, position: "fixed", background: PALETTE.LIGHTGRAY, zIndex: 101 }}
          >
            <Container
              onClick={() => navigate("/subscriptions")}
              className="rounded-md shadow m-auto p-1"
              style={{
                width: "100%",
                cursor: "pointer",
                textAlign: "center",
                background: PALETTE.GRADIENT,
                zIndex: 100,
              }}
            >
              <div
                className="text-center align-self-center"
                style={{
                  paddingTop: 15,
                  paddingBottom: 15,
                  color: PALETTE.WHITE,
                  borderRadius: 16,
                }}
              >
                <span>Passa a Premium</span>
              </div>
            </Container>
          </div>
        </div>
      )}

      {isMobile ? (
        <div>
          <Row className="m-auto text-center">
            <Col
              lg={6}
              className="m-auto px-0 align-self-center"
              style={{
                backgroundImage: `url(${exercise.cover})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                aspectRatio: 1,
                height: "60vh",
                cursor: "pointer",
              }}
              onClick={() => setPlaying(true)}
            >
              <div
                className="text-center align-items-center m-auto align-self-center"
                style={{ height: "100%", width: "100%", background: PALETTE.CIRCLETRANSPARENTGRADIENT, display: "inline-flex" }}>
                <FaPlay size={50} className="align-items-center text-center m-auto" color={PALETTE.WHITE} />
              </div>
            </Col>
            <Col lg={6} className="py-3">
              <Row className="text-start py-3">
                <p style={{ fontWeight: "bold", fontSize: 24 }}>{exercise.name}</p>
                <p>{exercise.description}</p>
              </Row>
            </Col>
          </Row>
        </div>
      ) : (
        <ContainerResponsive>
          <Row className="m-auto text-center">
            <Col lg={6} className="m-auto px-0">
              <div
                className="rounded-md shadow m-auto"
                style={{
                  maxWidth: "100%",
                  height: "60vh",
                  backgroundImage: `url(${exercise.cover})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  aspectRatio: 1,
                  cursor: "pointer",
                }}
                onClick={() => setPlaying(true)}
              >
                <div
                  className="text-center align-items-center m-auto align-self-center"
                  style={{ height: "60vh", width: "100%", background: PALETTE.CIRCLETRANSPARENTGRADIENT, display: "inline-flex" }}>
                  <FaPlay size={50} className="align-items-center text-center m-auto" color={PALETTE.WHITE} />
                </div>
              </div>
            </Col>
            <Col lg={6} className="py-3">
              <Row className="text-start py-3">
                <p style={{ fontWeight: "bold", fontSize: 24 }}>{exercise.name}</p>
                <p>{exercise.description}</p>
              </Row>
            </Col>
          </Row>
        </ContainerResponsive>
      )
      }
    </div>
    //     <div style={{ paddingBottom: paddingBottom }}>
    //       <ReactPlayer
    //         light={`${exercise.cover}`}
    //         id="workout-video"
    //         style={{ objectFit: "cover" }}
    //         className="m-auto"
    //         width="100%"
    //         controls={true}
    //         playing={playing}
    //         onStart={onVideoPlay}
    //         onPause={() => setPlaying(false)}
    //         // Disable download button
    //         config={{
    //           file: {attributes: {controlsList: "nodownload" } },
    //         }}
    //         onClickPreview={() => {
    //           setPlaying(true);
    //         }}
    //         // Disable right click
    //         onContextMenu={(e) => e.preventDefault()}
    //         pip={true}
    //         stopOnUnmount={false}
    //         playsinline={true}
    //         url={exercise.video}
    //       />
    //       <br />
    //       <DetailSector
    //         title={exercise.name}
    //         child={<p>{exercise.description}</p>}
    //       />
    //     </div>
    // </div>
  );
}
